import React, { FC, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Sick from "./tabs/Sick";
import { Wrapper } from "../styled";

const sickLeaveTabs = [
{
    title: "Больничные листы",
    component: <Sick/>,
}
];

const SickLeave: FC = () => {
const [tab, setTab] = useState(0);

const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
};

return (
    <Wrapper>
    <Tabs
        value={tab}
        onChange={handleChangeTab}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
    >
        {sickLeaveTabs.map((tab) => (
        <Tab key={tab.title} label={tab.title} />
        ))}
    </Tabs>
    {sickLeaveTabs[tab].component}
    </Wrapper>
);
};

export default SickLeave;
